import React from "react";

const RefundPolicy = () => (
  <div
    style={{ minHeight: "100vh", background: "#050A18", padding: "0 0 48px 0" }}
  >
    <div
      style={{
        background: "#111827",
        color: "#fff",
        padding: "56px 0 36px 0",
        textAlign: "center",
      }}
    >
      <div className="text-3xl font-bold tracking-wide text-center mb-2">
        <h2>
          <span className="text-[#4FA0FF]">Refund</span>
          <span className="text-[white] ml-1">Policy</span>
        </h2>
        
      </div>

     
    </div>

    <div
      style={{
        maxWidth: 900,
        margin: "40px auto",
        background: "#111827",
        borderRadius: 16,
        boxShadow: "0 4px 24px 0 rgba(79, 160, 255, 0.1)",
        padding: "40px 28px",
        color: "#1D3557",
        fontSize: "1.08rem",
        lineHeight: 1.7,
        border: "1px solid gray",
      }}
    >
      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          Refund Policy
        </h2>
        <p className="text-gray-300">
          At Kubermax, we value our customers and are committed to providing the best service. 
          The refund process will only be initiated by Kubermax under the following conditions:
        </p>
        <p className="text-gray-300" style={{ marginTop: 12 }}>
          We will not pass your details on to any third party.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          Conditions for Refund
        </h2>
        <ul style={{ paddingLeft: 20, listStyleType: "disc", marginTop: 12 }}>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            If repayment of the loan has been made by the borrower twice by any means.
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            Any extra payment has been received by Kubermax over and above the repayment value in any case.
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            Repayment has been made mistakenly by the borrower unintentionally before his/her due date of loan repayment.
          </li>
        </ul>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          Customer Satisfaction
        </h2>
        <p className="text-gray-300">
          If, for unforeseen reasons, the client is not satisfied with our services, they can call us for advice on future calls. 
          We will do our best to increase satisfaction in such cases.
        </p>
      </section>

      <section>
        <p className="text-gray-300">
          We strongly encourage our visitors and potential customers to read the refund policy before making a payment. 
          If the customer is entitled to a refund, the refund amount will be credited to the respective bank account within 7 working days.
        </p>
        <div style={{ marginTop: "32px", paddingTop: "16px", borderTop: "1px solid rgba(75, 85, 99, 0.5)" }}>
          <p style={{ fontSize: "0.875rem", color: "#9ca3af", marginBottom: "4px" }}>
            <strong style={{ color: "#4FA0FF" }}>Approved By:</strong> Management
          </p>
          <p style={{ fontSize: "0.875rem", color: "#9ca3af" }}>
            <strong style={{ color: "#4FA0FF" }}>Effective From:</strong> 15 April 2025
          </p>
        </div>
      </section>
    </div>
  </div>
);

export default RefundPolicy;